import { EnrolComponent } from "@modules/elearning/enrol";
import { LayoutMain } from "@unisearch/theme/layout";
import React from "react";

const Enrol = () => {
  return (
    <LayoutMain title="eLearning">
      <EnrolComponent />
    </LayoutMain>
  );
};

export default Enrol;
